import { useAgencyDashboardFeature } from '../../console/dashboard/agency/agency-dashboard.statics';
import { usePlatformLanguage } from '../../utils/hooks/usePlatformLanguage';
import { agencyShell, type AgencyShell } from './agencyShell';
import { useBrokerExperienceV2 } from './useBrokerExperienceV2';

/**
 * How the agency persona's page is dressed right now: `agencyShell` applied to the broker experience flag, the
 * agency's opt-in to the next dashboard, and the platform language. Everything that has to agree about the sidebar,
 * the header and the dashboard reads it from here.
 */
export function useAgencyShell(): AgencyShell {
  const agencyDashboardFeature = useAgencyDashboardFeature();
  const region = usePlatformLanguage();
  const brokerV2 = useBrokerExperienceV2();

  return agencyShell({
    brokerV2,
    optInNewAgent: agencyDashboardFeature.on,
    region,
  });
}
